import ma from "../assets/images/blog/ma.jpg";
import fada from "../assets/images/blog/9.jpeg";
import gigiri from "../assets/images/blog/10.jpg";
import kirehe from "../assets/images/solar/kah.webp";
import { mediaUrl } from "./siteApi";

export const CLASSIC_PROJECTS = [
  {
    test: (p) => /ma campagne|muhazi/i.test(`${p?.title || ""} ${p?.location || ""}`),
    title: "Rwanda: 25kWp Solar Power System Installation at Ma Campagne Resort Muhazi",
    image: ma,
    file: "/uploads/projects/ma-campagne.jpg",
  },
  {
    test: (p) => /fada/i.test(`${p?.title || ""} ${p?.location || ""}`),
    title: "Tchad: 100kWp Solar power system Installation at Fada Hospital",
    image: fada,
    file: "/uploads/projects/fada-hospital.jpeg",
  },
  {
    test: (p) => /gigiri|gigili|un office/i.test(`${p?.title || ""} ${p?.location || ""}`),
    title: "Kenya: 515kWp Solar power system for UN office Gigiri, Nairobi",
    image: gigiri,
    file: "/uploads/projects/un-gigiri.jpg",
  },
  {
    test: (p) => /kirehe|pumping/i.test(`${p?.title || ""} ${p?.location || ""}`),
    title: "Rwanda: Solar water pumping system of 75kWp at Kirehe District",
    image: kirehe,
    file: "/uploads/projects/kirehe-pumping.webp",
  },
];

export function classicProject(item) {
  if (!item) return null;
  return CLASSIC_PROJECTS.find((entry) => entry.test(item)) || null;
}

export function projectHeadline(item) {
  return classicProject(item)?.title || item?.title || "Project";
}

export function projectPhoto(item) {
  const classic = classicProject(item);
  if (classic) return classic.image;
  return mediaUrl(item?.imageUrl) || "";
}

export function orderProjectsForHome(items = []) {
  const used = new Set();
  const ordered = [];
  CLASSIC_PROJECTS.forEach((entry) => {
    const hit = items.find((item) => !used.has(item.id) && entry.test(item));
    if (hit) {
      used.add(hit.id);
      ordered.push(hit);
    }
  });
  items.forEach((item) => {
    if (!used.has(item.id)) ordered.push(item);
  });
  return ordered;
}
